<template lang="html">


    <!-- Sidebar -->
    <div class="border-right" id="sidebar-wrapper">
      <div class="header-sidebar" slot="header">
          <img :src="basepath+'/unodc_logo.png'" alt="" width="200px" />
      </div>
      <div class="list-group list-group-flush">

      
         <router-link to="/dashboard/Trainer/trainerPrevTraining" class="list-group-item list-group-item-action">
            <i class="material-icons">home</i> Home
          </router-link>
          <router-link
          :to="{ path: '/dashboard/Trainer/trainerDashboard', query: { training:AssigntrainingCode  }}"
        class="list-group-item list-group-item-action">
            <i class="material-icons">ballot</i> Pending Actions <span class="badge badge-danger pl-2 pr-2" style="font-size:14px">{{pendingActions}}</span>
          </router-link>
          <router-link to="/dashboard/Trainer/QuestionBank" class="list-group-item list-group-item-action">
            <i class="material-icons">create_new_folder</i> Create Question Bank
          </router-link>

         
          <router-link to="/dashboard/Trainer/TrainerknowledgeBase" class="list-group-item list-group-item-action">
             <i class="material-icons">file_copy</i> Knowledge Base
          </router-link>

         
          <router-link to="/dashboard/Trainer/Trainer_Registration_Form" class="list-group-item list-group-item-action">
            <i class="material-icons">ballot</i> Profile Settings
          </router-link>
          
          <div style="margin-bottom:130px">
            <router-link to="/dashboard/trainer/reportsTrainerAll"  slot="header" class="list-group-item list-group-item-action" id="mybutton">
            <i class="material-icons pr-1">chrome_reader_mode</i
            ><b> Reports</b>
             </router-link>
          </div>
       </div>
    </div>
</template>

<script>
// import { bus } from "../../../main";
import axios from "axios";
export default {
  data: () => ({
    isSidebar: false,
    pendingActions :0,
    active: true,
    basepath: localStorage.getItem("BASE_PATH")
  }),
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    // Set the initial number of items
    // this.totalRows = this.items.length;
    this.allTrainings();
  },
  created() {
    // bus.$on("sidebarStatus", data => {
    //   this.active = data;
    // });
  },
  methods: {
     allTrainings: function allTrainings() {
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainer/trainings/" +
            JSON.parse(localStorage.getItem("currentUser")).id +
            "/filter"
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          if (response.data && response.data != "") {
            this.pendingActions = response.data.length;
            
          }
        });
    },
    // isSidebar() {
    //   bus.$emit("sidebarStatus", this.active);
    // }
  }
};
</script>
<style>
/* .list-group-item:hover {
  padding-left: 30px;
  transition: 0.5s ease;
} */
</style>

<style scoped>
/*!
 * Start Bootstrap - Simple Sidebar (https://startbootstrap.com/template-overviews/simple-sidebar)
 * Copyright 2013-2019 Start Bootstrap
 * Licensed under MIT (https://github.com/BlackrockDigital/startbootstrap-simple-sidebar/blob/master/LICENSE)
 */

body {
  overflow-x: hidden;
}

.material-icons {
  font-size: 20px !important;
  vertical-align: bottom;
}
#sidebar-wrapper {
  min-height: 100vh;
  margin-left: -15rem;
  -webkit-transition: margin 0.25s ease-out;
  -moz-transition: margin 0.25s ease-out;
  -o-transition: margin 0.25s ease-out;
  transition: margin 0.25s ease-out;
}

#sidebar-wrapper .sidebar-heading {
  padding: 0.875rem 1.25rem;
  font-size: 1.2rem;
}

#sidebar-wrapper .list-group {
  width: 15rem;
}

#page-content-wrapper {
  min-width: 100vw;
}

#wrapper.toggled #sidebar-wrapper {
  margin-left: 0;
}

@media (min-width: 768px) {
  #sidebar-wrapper {
    margin-left: 0;
  }

  #page-content-wrapper {
    min-width: 0;
    width: 100%;
  }

  #wrapper.toggled #sidebar-wrapper {
    margin-left: -15rem;
  }
}
/* scrollbar css starts */
/* width */
::-webkit-scrollbar {
  width: 5px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
  /* -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3); */
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: rgba(7, 167, 225);
  border-radius: 50px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: rgba(7, 167, 225);
}
/* scrollbar css ends */
</style>